import { Fieldset, Textarea } from '@fourthwall/components';
import React from 'react';
import { useTierContext } from '../../hooks/useTierContext';
import { FormFields } from '../../providers/TierProvider/types';
export const Description = () => {
    const { form, isLoading } = useTierContext();
    return (React.createElement(Fieldset.Row, null,
        React.createElement(Fieldset.Item, null,
            React.createElement(Textarea, { label: "Description (optional)", placeholder: "Description (optional)", disabled: isLoading, ...form.getFieldProps(FormFields.description) }))));
};
